import { FlowInterface, PaymentOptionInterface } from '@pe/checkout/types';

import { roundValue } from './round.util';

export function totalFee(option: PaymentOptionInterface, flow: FlowInterface): number {
  return roundValue(option.fixedFee + 0.01 * option.variableFee * flow.total);
}
